import AiProvider from "./AiProvider";
import { lazyAiComponent } from "./lazyAiComponent";

const LeadCallSummary = lazyAiComponent("LeadCallSummary");

const AiLeadCallSummary = ({ className, leadPersonUuid }: { className?: string, leadPersonUuid: string }) => (
  <AiProvider>
    <LeadCallSummary className={className} leadPersonUuid={leadPersonUuid} />
  </AiProvider>
);

export default AiLeadCallSummary;
